import { useIntl } from "react-intl";
import { useBrandLoaderData } from "../../../../root/rootLoader";
import styles from "./Logo.module.css";

export default function Logo() {
  const intl = useIntl();
  const brand = useBrandLoaderData();

  return (
    <img
      src={brand.logo}
      alt={intl.formatMessage(
        { defaultMessage: "{brand} Logo" },
        { brand: brand.name }
      )}
      className={styles.logo}
    />
  );
}
